<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

  <div class="flex justify-between lg:pr-2 lg:pl-0">
    <div>
      <div *ngIf="fundingSourceDetails" class="border border-solid border-gray-200 p-1 relative flex min-w-0 items-center gap-3 rounded-lg text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5">
        <div class="flex flex-row gap-2 items-center">
          <div class="w-7 h-7 overflow-hidden inline-grid shrink-0 align-middle [--avatar-radius:20%] [--ring-opacity:20%] *:col-start-1 *:row-start-1 outline outline-1 -outline-offset-1 outline-black/[--ring-opacity] dark:outline-white/[--ring-opacity] rounded-[--avatar-radius] *:rounded-[--avatar-radius]">
            <img src="{{fundingSourceDetails.profileImageURL ? fundingSourceDetails.profileImageURL : 'assets/images/company-placeholder.png'}}" class="size-full object-cover">
          </div>
          <div class="font-semibold">
            {{fundingSourceDetails.title | titlecase}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
    <div class="flex flex-col gap-2 sm:flex-row">
      <div class="relative">
        <input type="text" [(ngModel)]="search" placeholder="Search.." class="pl-8" />
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      </div>
      <div>
        <select [(ngModel)]="status" id="inputStatus" class="min-w-40" (change)="onSelectStatus()">
          <option [ngValue]="true">Active</option>
          <option [ngValue]="false">Inactive</option>
        </select>
      </div>
    </div>
  
    <div *ngIf="filteredFareList && filteredFareList.length">
      <h1 class="text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (filteredFareList.length != 50? (50
        -filteredFareList.length) : 0) }} of {{totalResults }} entries
      </h1>
    </div>
    <div>
      <button *ngIf="companyId && permissionService.hasPermission([userPermission.MANAGE_FARES])"
        routerLink="/credentials/company/{{ companyId }}/fare/add" class="btn btn-secondary">
        Add
      </button>
  
      <button *ngIf="!companyId && fundingSourceId && permissionService.hasPermission([userPermission.MANAGE_FARES])"
        routerLink="/funding-sources/{{ fundingSourceId }}/fare/add" class="btn btn-secondary">
        Add
      </button>
  
    </div>
  
  
  </div>

  <div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">

    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>
                   <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      #
                  </th>
                  <th 
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap"
                    *ngIf="permissionService.hasPermission([userPermission.MANAGE_FARES])"                    >
                      Action
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Name</th>
                  <!-- LOS -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    LOS</th>
                  <!-- Space Type -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Space Type</th>
                    <!-- Type -->
                    <th
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Type</th>
                  <!-- Day(s) -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Day(s)</th>
                  <!-- Start Time -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Start Time</th>
                  <!-- End Time -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    End Time</th>
                  <!-- Base Rate -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Base Rate</th>
                  <!-- Per Mile -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Per Mile</th>
                  <!-- Per Minute -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Per Minute</th>
                  <!-- Minimum Fare -->
                  <!-- Cancel Charge -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Cancel Charges</th>
                  <!-- No Show Charge	 -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    No Show Charges</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   Status</th>
             
                  
                </tr>
              </thead>
              <tbody>
                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                  *ngFor="let fare of filteredFareList  | filter: search | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index">
                
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   {{i+1}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" *ngIf="permissionService.hasPermission([userPermission.MANAGE_FARES])" >
                    <div class="flex items-center">
                      <button  [appToolTip]="'Edit'" [routerLink]="getEditLink(fare.id)" class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="size-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                        </svg>
                      </button>
                      <div class="mx-2 h-6 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                      <a [appToolTip]="'Logs'" href="javascript:void(0)" (click)="openLogModal(fare)"
                        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center py-1 text-sm"
                        role="menuitem" tabindex="-1" id="menu-item-0">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-main-primary"
                            viewBox="0 0 48 48"><!-- Icon from IconPark Outline by ByteDance - https://github.com/bytedance/IconPark/blob/master/LICENSE -->
                            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4">
                              <path stroke-linejoin="round" d="M24 44H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v18m-4.5 20V31" />
                              <path stroke-linejoin="round" d="m31 34.5l1.5-1.5l3-3l3 3l1.5 1.5" />
                              <path d="M16 16h16m-16 8h8" />
                            </g>
                          </svg>
                      </a>
                    </div>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{(fare.name | titlecase) || ' N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{((preLevelOfServices[fare.los]?.title) | uppercase) || ' N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{((preSpacetypes[fare.spaceType]?.title) | uppercase) || ' N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{(fare.type | titlecase) || ' N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                    <div class="flex gap-1">
                      <span class="badge-primary" *ngFor="let dayLabel of getDayLabels(fare.days)">
                        {{ ((dayLabel) | titlecase) || ' N/A' }}
                      </span>
                    </div>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{(fare.startTime | date:'HH:mm') || ' N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{(fare.endTime | date:'HH:mm') || ' N/A'}}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{ fare?.baseFare?.fare ? (fare.type === 'percentage' ? (fare.baseFare.fare + '%') : ('$' + fare.baseFare.fare)) : 'N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{ fare.perMile ? ('$' + fare.perMile) : 'N/A' }}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{ fare.perMin ? ('$' + fare.perMin) : 'N/A' }}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  {{ fare?.cancelCharges?.value ? (fare.cancelCharges.type === 'percentage' ? (fare.cancelCharges.value + '%')
                  : ('$' + fare.cancelCharges.value)) : ' N/A' }}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  {{ fare?.noShowCharges?.value ? (fare.noShowCharges.type === 'percentage' ? (fare.noShowCharges.value + '%')
                  : ('$' + fare.noShowCharges.value))
                  : ' N/A'
                  }}
                </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <span [ngClass]="fare.isActive ? 'badge-success' : 'badge-danger'" class="">
                      {{fare.isActive ? 'Active' : 'Inactive'}}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end">
      <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div>
    
  </div>

</section>

<app-onboarding-logs-modal *ngIf="logObj" [source]="'fare'" [tripId]="logObj" (closeModal)="logObj = null"></app-onboarding-logs-modal>
